import React, { useContext } from 'react'

import { UserContext } from '@doist/marketist'

import { Footer, Navbar, Seo } from 'components'
import { FAQ } from 'components/Pricing/FAQ/Faq'
import { PricingHeader } from 'components/Pricing/Header/Header'
import { Plans } from 'components/Pricing/Plans/Plans'
import { SlackLacks } from 'components/Pricing/slack-lacks/slack-lacks'
import { GetServerSidePropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getCommonServerSideProps } from 'services'
import { getOgImageURL } from 'services/ogimage'
import { getPricingModel, PriceTable, SupportedCurrencies } from 'services/pricing/price-table'

interface PricingProps {
    currency: SupportedCurrencies
    priceTable: PriceTable
}

export const Pricing: NextPage<PricingProps> = ({ currency, priceTable }) => {
    const { isAuthenticated } = useContext(UserContext)
    const { t, i18n } = useTranslation('pricing')

    return (
        <>
            <Navbar isAuth={isAuthenticated} />
            <Seo
                path="/pricing"
                title={t('seoTitle')}
                description={t('seoDescription')}
                images={[
                    {
                        url: getOgImageURL('og-image-pricing.jpg', i18n.language),
                        alt: t('seoImageAlt'),
                    },
                ]}
                lang={i18n.language}
            />
            <PricingHeader />
            <Plans currency={currency} priceTable={priceTable} />
            <SlackLacks />
            <FAQ />
            <Footer textSize="major-xl" hairlineBackgroundColor="var(--ui-border)" />
        </>
    )
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    const { locale, ...commonProps } = await getCommonServerSideProps(ctx)

    const priceTable = await getPricingModel()

    return {
        props: {
            ...commonProps,
            priceTable,
            ...(await serverSideTranslations(locale, ['common', 'pricing'])),
        },
    }
}

export default Pricing
